var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"text-button-link"},[_c(_vm.link ? 'a' : 'span',{tag:"component",staticClass:"text-button-link__link",attrs:{"href":_vm.link,"target":_vm.target}},[_vm._t("default"),_vm._v(" "),(_vm.hasArrow)?_c('CarouselArrow',{staticClass:"text-button-link__vector"}):_vm._e()],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }